import { render, staticRenderFns } from "./SetSchoolAdmin.vue?vue&type=template&id=dd3b70ea"
import script from "./SetSchoolAdmin.vue?vue&type=script&lang=js"
export * from "./SetSchoolAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports